import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AutoDetail } from '../../../../../models/api/view/claim/details/auto/auto-detail';
import { AutoInsuredVehicle } from '../../../../../models/api/view/claim/details/auto/auto-insured-vehicle';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { SsnLabelComponent } from '../../../../core/labels/ssn-label.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-insured-vehicle-au',
  imports: [
    CommonModule,
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    SsnLabelComponent,
    AddressLabelComponent,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8">
      <app-card label="Insured Vehicle" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="vehicleData">
          <app-detail-item label="vehicle number" name="vehicleNumber" />
          <app-detail-item label="make" name="make" />
          <app-detail-item label="model" name="model" />
          <app-detail-item label="year" name="year" />
          <app-detail-item label="VIN" name="vin" labelCase="none" />
          <app-detail-item label="plate" name="plate" />
          <app-detail-item label="state" name="plateState" />
          <app-detail-item label="other insurance" name="otherInsurance" />
          <app-detail-item label="vehicle type" name="vehicleType" />
          <app-detail-item label="estimate" name="estimate" format="c" />
          <app-detail-item label="location" name="location" />
          <app-detail-item label="when seen" name="whenSeen" />
          <app-detail-item label="purpose of use" name="purposeOfUse" />
          <app-detail-item label="permission for use" name="permissionForUse" />
        </app-detail-panel>
      </app-card>
      <app-card label="Driver" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="driverData">
          <app-detail-item label="name" name="driverName" />
          <app-detail-item label="address" name="driverAddress">
            <ng-template #labelTemplate let-value>
              <app-address-label
                [street1]="driverData.driverAddress"
                [city]="driverData.driverCity"
                [state]="driverData.driverState"
                [postalCode]="driverData.driverZip"
                [country]="driverData.driverCountry"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item
            label="home phone"
            name="driverPhoneHome"
            format="p"
          />
          <app-detail-item
            label="work phone"
            name="driverPhoneWork"
            format="p"
          />
          <app-detail-item label="relationship" name="relationship" />
          <app-detail-item label="job title" name="jobTitle" />
          <app-detail-item label="birth date" name="birthDate" format="d" />
          <app-detail-item label="hire date" name="hireDate" format="d" />
          <app-detail-item label="License number" name="licenseNumber" />
          <app-detail-item label="License state" name="licenseState" />
          @if (showDriverSSN) {
            <app-detail-item label="Driver SSN" name="driverSSN" labelCase="none">
              <ng-template #value let-data>
                <app-ssn-label [value]="data.driverSSN || ''" />
              </ng-template>
            </app-detail-item>
          }
        </app-detail-panel>
      </app-card>
      <app-card label="Owner" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="ownerData">
          <app-detail-item label="name" name="ownerName" />
          <app-detail-item label="address" name="ownerAddress">
            <ng-template #labelTemplate let-value>
              <app-address-label
                [street1]="value"
                [city]="ownerData.ownerCity"
                [state]="ownerData.ownerState"
                [postalCode]="ownerData.ownerZip"
                [country]="ownerData.ownerCountry"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item label="cell phone" name="ownerPhone" format="p" />
          <app-detail-item label="owner type" name="vehicleOwnerType" />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class InsuredVehicleAuComponent extends BaseComponent implements OnInit {
  @Input() autoDetail: AutoDetail;

  // Security - SSN visibility
  showDriverSSN = false;

  ngOnInit(): void {
    this.view.hideLoading();
    // Check field security for Driver SSN
    const restrictedFields =
      this.session.user?.fieldSecurity?.restrictedFields || [];
    this.showDriverSSN = !restrictedFields.includes('DriverSSN');
  }

  get vehicle(): AutoInsuredVehicle {
    return this.autoDetail?.insuredVehicle || {};
  }

  get vehicleData(): Partial<AutoInsuredVehicle> {
    return this.vehicle;
  }

  get driverData(): Partial<AutoInsuredVehicle> {
    return this.vehicle;
  }

  get ownerData(): Partial<AutoInsuredVehicle> {
    return this.vehicle;
  }
}
